import * as React from "react";
const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

export const GoogleSignIn: React.FC = () => {
  React.useEffect(() => {
    try {
      if (!googleClientId) {
        throw new Error("Google Client ID not configured");
      }
      // Get the full URL for the callback page
      const a = document.createElement("a");
      a.href = "/google-callback.html";
      const redirectUri = a.href;
      const state = Math.random().toString(36).substring(2);
      const nonce = Math.random().toString(36).substring(2);
      const googleAuthUrl =
        "https://accounts.google.com/o/oauth2/v2/auth?" +
        "client_id=" +
        encodeURIComponent(googleClientId) +
        "&redirect_uri=" +
        encodeURIComponent(redirectUri) +
        "&response_type=id_token" +
        "&scope=" +
        encodeURIComponent("openid email profile") +
        "&state=" +
        state +
        "&nonce=" +
        nonce +
        "&prompt=select_account";
      window.location.replace(googleAuthUrl);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error:", error);
      if (window.Office && Office.context && Office.context.ui) {
        Office.context.ui.messageParent(
          JSON.stringify({
            type: "error",
            message: error.message,
          })
        );
      }
    }
  }, []);
  console.log("google signin");
  return (
    <div style={{ textAlign: "center", padding: 20 }}>
      <p>Redirecting to Google Sign In...</p>
      <p>Please wait...</p>
    </div>
  );
};
